// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorStorefrontTheme = (client) => ({
    /**
     * `DELETE /vendor/storefront-theme`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorStorefrontThemeDelete
     * @source apps/backend/src/api/vendor/storefront-theme/route.ts
     */
    delete: (body, query, headers) => client.fetch("/vendor/storefront-theme", { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/storefront-theme`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorStorefrontThemeList
     * @source apps/backend/src/api/vendor/storefront-theme/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/storefront-theme", { method: "GET", query, headers }),
    /**
     * `PUT /vendor/storefront-theme`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorStorefrontThemePut
     * @source apps/backend/src/api/vendor/storefront-theme/route.ts
     */
    update: (body, query, headers) => client.fetch("/vendor/storefront-theme", { method: "PUT", body, query, headers }),
    /**
     * `POST /vendor/storefront-theme/upload`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorStorefrontThemeUpload
     * @source apps/backend/src/api/vendor/storefront-theme/upload/route.ts
     */
    upload: (body, query, headers) => client.fetch("/vendor/storefront-theme/upload", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=storefront-theme.js.map